import { createValidator, optionalStringLength, stringTrim } from 'app/validators/base'

const validate = optionalStringLength({ min: 15, max: 150 }, stringTrim)

export default createValidator(validate, 'question')
